<template>
  <div id="contenedor-eliminar-tipo-obra">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar tipo de obra </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el tipo de obra "{{tipoObraEliminar.descripcion}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarTipoObra"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoTiposObra from './mixCatalogoTiposObra';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosTiposObraEliminar',
  mixins: [mixCatalogoTiposObra],
  props: {
    tipoObraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
